<h2 mat-dialog-title>Submit Feedback</h2>
<mat-dialog-content>
	<mat-form-field appearance="outline" class="w-100">
		<mat-label>Type</mat-label>
		<mat-select [(ngModel)]="type">
			<mat-option value="feedback">General Feedback</mat-option>
			<mat-option value="error">Report an Error</mat-option>
		</mat-select>
	</mat-form-field>

	<mat-form-field appearance="outline" class="w-100">
		<mat-label>Description</mat-label>
		<textarea
			matInput
			[(ngModel)]="description"
			rows="5"
			placeholder="Please describe your feedback or the error you encountered..."
		></textarea>
	</mat-form-field>
</mat-dialog-content>
<mat-dialog-actions align="end">
	<button mat-button mat-dialog-close>Cancel</button>
	<button
		mat-raised-button
		color="primary"
		[mat-dialog-close]="{ description, type }"
		[disabled]="!description"
	>
		Submit
	</button>
</mat-dialog-actions>
